import axios from 'axios'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import swal from "sweetalert";

export const useFreeCost = (data) => {

    const [freeRegBuffer, setFreeRegBuffer] = useState(false);
    const history = useHistory();

    const freeRegistration = (type) => {
        setFreeRegBuffer(true)
            axios.post(`/api/user/free-cost-request/${type}`, data).then((res) => {
                swal("Success", 'Registration Done', "success");
                // history.push("/");
                setFreeRegBuffer(false)
            }).catch((err) => {
                console.log(err.message)
            });
       
    };

    return { freeRegistration, freeRegBuffer }

}

